module.exports = __webpack_public_path__ + "static/media/S2N10-4.6e5017b9.svg";